import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import parse from "html-react-parser";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import AWS from "aws-sdk";
import {
  createTextToSpeechCompletion,
  addTranscriptLanguage,
} from "../api/apiHandler";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import "react-h5-audio-player/lib/styles.css";
import chatLoader from "../assets/chatloader.gif";

import constant from "../constant/constant";

import AutoPrescriptionPopup from "./footer/Common/AutoPrescriptionPopup";
import TextReader from "./TextReader";

const StarpilotChat = ({
  invite,
  setInvite,
  guest,
  addMonteChatTranscript,
  transacriptName,
  buttonClick,
  screenShareBtn,
  handleScreenShare,
  handleScreenShareBtn,
  videoBtn,
  videoTiles,
  handleOtherUserJoin,
  leaveBtn,
  leaveMeeting,
  autoPrescMain,
  audioStatus,
  handleAudio,
  callCreated,
  setLanguage,
  setPatientLanguage,
  language,
  patientLanguage,
  setChat,
  chat,
  meetingid,
  invitedId,
  activeChat,
  setActiveChat,
  resetTranscript: resetListeningTranscript,
  setPatientName,
  patientName,
  showIsNameModal,
  setShowIsNameModal,
  conversation,
  loadingChat,
  setLoadingChat,
  audible,
  setAudible,
  speak,
  cancel,
  speaking,
  supported,
  voices,
  speakingText,
  setSpeakingText,
  translatedText,
}) => {
  const location = useParams();
  const audioRef = useRef(null);
  const fileInputRef = useRef(null);
  const [pocType, setPocType] = useState(location.poc_type);
  const [searchValue, setSearchValue] = useState("");
  const [optionSelected, setOptionSelected] = useState(false);

  const [instruction] = useState(constant?.auto_rx_instruction);
  console.log("transacriptName-->", transacriptName);
  console.log(conversation, "conversationsssss");
  const [activeIndex, setActiveIndex] = useState(null);
  const [image, setImage] = useState("");
  const [fileType, setFileType] = useState(null);
  const [showChat, setShowChat] = useState(true);
  const [uploadImage, setUploadImage] = useState(null);
  const [searchTextValue, setSearchTextValue] = useState("");
  const [timeoutId, setTimeoutId] = useState(null);
  const [loadingSpeaker, setLoadingSpeaker] = useState({
    status: false,
    index: "",
  });
  const [audioData, setAudioData] = useState({
    url: "",
    text: "",
    playStatus: false,
  });
  const [uuid, setUuid] = useState("");
  // console.log("uuid usestae", uuid);
  const [isNewchat, setIsNewChat] = useState(1);
  const [handleSweetAlert, setHandleSweetAlert] = useState(true);
  const [showListeningModal, setListeningModal] = useState(false);
  const [handleStartStopListening, setStartStopListening] = useState(true);
  const [intervalId, setIntervalId] = useState(null);
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();

  const validationSchema = Yup.object().shape({
    prompt: Yup.string().required("prompt is required"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState, reset, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  const [visibleIndexes, setVisibleIndexes] = useState(
    Array(conversation.length).fill(true)
  );

  const toggleMessage = (index) => {
    const updatedVisibility = [...visibleIndexes];
    updatedVisibility[index] = !updatedVisibility[index];
    setVisibleIndexes(updatedVisibility);
  };

  useEffect(() => {
    setVisibleIndexes(Array(conversation.length).fill(true));
  }, [conversation]);
  const chatBoxRef = useRef(null);
  const lastMessageRef = useRef(null);
  const [isAutoScroll, setIsAutoScroll] = useState(true);

  const handleScroll = () => {
    const el = chatBoxRef.current;
    if (!el) return;
    const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 50;
    setIsAutoScroll(isAtBottom);
  };

  useEffect(() => {
    if (isAutoScroll && lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [conversation]);

  const emptyImage = async () => {
    try {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input field
      }
      console.log("empyimage");
      setImage("");
      setUploadImage(null);
      setFileType("");
    } catch (error) {}
  };

  console.log("setFileType-->", fileType);

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };
      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  const onSubmitBtn = async (data) => {
    try {
      console.log("onSubmitBtn", data);
      resetListeningTranscript();
      setActiveChat(data);
    } catch (e) {
      console.log("error-->", e);
    }
  };

  const handleAudioEnd = () => {
    // console.log('Audio has ended');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    // Add any additional logic you want to execute when audio ends here
  };

  const stopAudio = () => {
    // console.log('Audio has Stoped');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    audioRef.current.pause();
    audioRef.current.currentTime = 0; // Resets audio to the start
  };

  console.log("Generated uuid:", isNewchat);

  const pocCreateTextToSpeechCompletion = (msg, key) => {
    if (audioData?.text && audioData?.text == msg) {
      setAudioData((prev) => ({ ...prev, playStatus: true }));
      audioRef.current.src = audioData?.url;
      audioRef.current.controls = true;
      audioRef.current.play();
    } else {
      setLoadingSpeaker({
        status: true,
        index: key,
      });
      createTextToSpeechCompletion({ text: msg }).then((res) => {
        // console.log('response===>', res)
        var response = JSON.parse(res);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          const arrayBuffer = response.data.buffer.data;
          // console.log("arrayBuffer==>", arrayBuffer)
          // Convert buffer data to Blob
          const byteArray = new Uint8Array(arrayBuffer);
          const blob = new Blob([byteArray], { type: "audio/mpeg" });
          // const blob = new Blob([arrayBuffer], { type: 'audio/mp3' });
          const url = URL.createObjectURL(blob);
          // setAudioSrc(url)
          // const audio = new Audio(url);
          // console.log("url==>", url)
          if (audioRef.current) {
            // console.log("test")
            audioRef.current.src = url;
            audioRef.current.controls = true;
            audioRef.current.play();
            setAudioData({
              url: url,
              text: msg,
              playStatus: true,
            });
          } else {
            // console.log("testfsed")
          }
        } else {
          // Swal.fire({
          //   position: 'top-end',
          //   icon: 'error',
          //   title: response.message,
          //   toast: true,
          //   showConfirmButton: false,
          //   timer: 2000
          // })
        }
        if (!handleSweetAlert) {
          // Swal.close()
        }
        setLoadingSpeaker({
          status: false,
          index: "",
        });
      });
    }
  };

  const closeListeningModal = () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    setStartStopListening(true);
    setListeningModal(false);
    setValue("prompt", searchValue, { shouldValidate: false });
  };

  const handleListening = () => {
    if (handleStartStopListening) {
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      setStartStopListening(false);
    } else {
      // SpeechRecognition.stopListening();
      // resetTranscript()
      // setStartStopListening(true)
      closeListeningModal();
    }
  };
  const onSubmitChat = async () => {
    console.log("searchTextValue--->", searchTextValue);
    if (searchTextValue || uploadImage) {
      const chatGptObj = {
        meeting_id: meetingid,
        prompt: searchTextValue,
      };
      if (uploadImage) {
        console.log("data: ");
        let imgUrl = "";
        await uploadData(uploadImage, "/analysis_file")
          .then((newImage) => {
            Swal.close();
            console.log("newImagenewImagenewImage", newImage);
            imgUrl = newImage;
          })
          .catch((e) => {
            Swal.close();
          });
        chatGptObj.imgUrl = `https://msh-dev.s3.amazonaws.com/analysis_file/${imgUrl}`;
        chatGptObj.imgType = fileType;
      }
      console.log("chatGptObj-->", chatGptObj);
      // chatCreateMonteChatTextReply(chatGptObj);
      addMonteChatTranscript(chatGptObj?.prompt);
    }
    setSearchTextValue("");
    emptyImage();
  };

  const selectLangFunc = async (lng, type) => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    addTranscriptLanguage({
      language: lng,
      meeting_id: meetingid,
    })
      .then(async (res) => {
        // console.log('response===>', res)
        var response = JSON.parse(res);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          if (response.data.language) {
            if (type == "patient") {
              setPatientLanguage(response.data.language);
            } else {
              setLanguage(response.data.language);
            }
          }
          Swal.close();
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      })
      .catch((e) => {
        console.log("error select lang ==>", e);
        Swal.close();
      });
  };

  return (
    <>
      <div
        className={`${chat && "w-100"} py-0 search-sec`}
        style={{
          bottom: 10,
          right: 10,
          zIndex: 999999,
        }}
      >
        <div className="chatMain bg-white">
          <div className="p-3" style={{ fontSize: 12 }}>
            <div className="form-horizontal m-t-30 position-relative">
              {loadingChat && (
                <div className="position-absolute top-50 start-0 translate-middle-y">
                  <span className="themeClr me-2 fw-bold">SP Responding</span>
                  <img
                    src={chatLoader}
                    alt="Loading..."
                    className="img-fluid "
                    style={{ height: 20 }}
                  />
                </div>
              )}

              <div
                className="container py-3 border rounded-3"
                style={{ maxWidth: 600 }}
              >
                <div className="d-flex gap-2">
                  <MainBtnWrpper className="d-flex align-items-center justify-content-between w-100 ">
                    <div
                      className="d-flex gap-2 status"
                      style={{ alignItems: "center" }}
                    >
                      <label
                        htmlFor="custom-switch"
                        className="d-block mb-0 p-0 nav-link active"
                      >
                        Status
                      </label>
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                        onChange={(x) => onSubmitBtn(x.target.checked)}
                        checked={activeChat}
                      />
                    </div>
                    <div
                      className="right d-flex align-items-center gap-10 meeting-widgets"
                      style={{ flex: "unset" }}
                    >
                      {activeChat && (
                        <p className="m-0 fw-sbold">
                          Listening{" "}
                          <img
                            src={chatLoader}
                            style={{ height: 20 }}
                            alt=""
                            className="img-fluid"
                          />
                        </p>
                      )}
                      {!callCreated ? (
                        ""
                      ) : (
                        <div
                          className="mute-widget"
                          style={{
                            background: "#216fc8",
                            // cursor: activeChat ? "pointer" : "not-allowed",
                            // opacity: activeChat ? 1 : 0.5,
                          }}
                        >
                          <i
                            className={
                              audioStatus
                                ? "fa-solid fa-microphone"
                                : "fa-solid fa-microphone-slash"
                            }
                            onClick={handleAudio}
                          />
                        </div>
                      )}
                      {!callCreated ? (
                        ""
                      ) : (
                        <div
                          className="mute-widget"
                          style={{ background: "#216fc8" }}
                        >
                          <i
                            className={"fa-solid fa-plus"}
                            onClick={handleOtherUserJoin}
                          />
                        </div>
                      )}

                      {videoTiles && (
                        <>
                          <div
                            className="mute-widget"
                            style={{ background: "#216fc8" }}
                          >
                            <i
                              className={
                                videoBtn
                                  ? "fa-solid fa-video"
                                  : "fa-solid fa-video-slash"
                              }
                              onClick={buttonClick}
                            />
                          </div>
                          <div
                            className="mute-widget"
                            style={{ background: "#216fc8" }}
                          >
                            {handleScreenShareBtn ? (
                              <img
                                src="/assets/images/icon/desktop.png"
                                style={{
                                  height: 20,
                                  filter: "brightness(500)",
                                }}
                                disabled={!screenShareBtn}
                                onClick={handleScreenShare}
                              />
                            ) : (
                              <img
                                src="/assets/images/icon/desktop-slash.png"
                                className="img-fluid object-fit-contain"
                                style={{
                                  height: 20,
                                  filter: "brightness(500)",
                                }}
                                disabled={!screenShareBtn}
                                onClick={handleScreenShare}
                              />
                            )}
                          </div>
                        </>
                      )}
                      {callCreated ? (
                        <AutoPrescriptionPopup
                          btnClass="mute-widget"
                          instruction={instruction}
                          onConfirm={autoPrescMain}
                        />
                      ) : (
                        ""
                      )}
                      {(callCreated &&
                        !guest &&
                        localStorage.getItem("user_login_type_role") == 2) ||
                      (callCreated &&
                        !guest &&
                        localStorage.getItem("user_login_type_role") == 4) ? (
                        <div
                          onClick={() => setInvite(!invite)}
                          className="mute-widget"
                          style={{ background: "#216fc8" }}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19 17V19H7V17C7 17 7 13 13 13C19 13 19 17 19 17ZM16 8C16 7.40666 15.8241 6.82664 15.4944 6.33329C15.1648 5.83994 14.6962 5.45542 14.1481 5.22836C13.5999 5.0013 12.9967 4.94189 12.4147 5.05764C11.8328 5.1734 11.2982 5.45912 10.8787 5.87868C10.4591 6.29824 10.1734 6.83279 10.0576 7.41473C9.94189 7.99667 10.0013 8.59987 10.2284 9.14805C10.4554 9.69623 10.8399 10.1648 11.3333 10.4944C11.8266 10.8241 12.4067 11 13 11C13.7956 11 14.5587 10.6839 15.1213 10.1213C15.6839 9.55871 16 8.79565 16 8ZM19.2 13.06C19.7466 13.5643 20.1873 14.1724 20.4964 14.8489C20.8054 15.5254 20.9766 16.2566 21 17V19H24V17C24 17 24 13.55 19.2 13.06ZM18 5C17.6979 5.00002 17.3976 5.04725 17.11 5.14C17.6951 5.97897 18.0087 6.97718 18.0087 8C18.0087 9.02282 17.6951 10.021 17.11 10.86C17.3976 10.9527 17.6979 11 18 11C18.7956 11 19.5587 10.6839 20.1213 10.1213C20.6839 9.55871 21 8.79565 21 8C21 7.20435 20.6839 6.44129 20.1213 5.87868C19.5587 5.31607 18.7956 5 18 5ZM8 10H5V7H3V10H0V12H3V15H5V12H8V10Z"
                              fill="#fff"
                            />
                          </svg>
                        </div>
                      ) : (
                        ""
                      )}

                      <button
                        className={leaveBtn ? "leave-btn" : "leave-btn-disable"}
                        onClick={leaveBtn ? leaveMeeting : undefined}
                        disabled={!leaveBtn}
                      >
                        Leave
                      </button>
                    </div>
                  </MainBtnWrpper>
                </div>
              </div>
            </div>
            <div
              className="ans-block overflow-auto border-0"
              style={{ maxHeight: "calc(-100px + 100vh)" }}
            >
              {(parseInt(localStorage.getItem("user_login_type_role")) == 2 ||
                parseInt(localStorage.getItem("user_login_type_role")) ==
                  4) && (
                <>
                  <div className="d-flex justify-content-end align-items-center gap-2 px-3">
                    <div className="my-3 row justify-content-around w-100">
                      {invitedId ? (
                        <div className="col-md-4 col-sm-6 my-3">
                          {language ? (
                            <label
                              htmlFor=""
                              className="form-label m-0 fw-bold text-blue"
                            >
                              Language: {language}
                            </label>
                          ) : (
                            <>
                              <label
                                htmlFor=""
                                className="form-label m-0 fw-bold"
                              >
                                Select Language:
                              </label>
                              <Form.Select
                                className="meeting-status status-ongoing text-white border-white font_16"
                                aria-label="Default select example"
                                onChange={(e) =>
                                  selectLangFunc(e.target.value, "doctor")
                                }
                              >
                                {/* {constant?.language.map((item) => (
                                  <option value={item}>{item}</option>
                                ))} */}
                                {constant?.language.map((item) => (
                                  <option value={item}>{item}</option>
                                ))}
                              </Form.Select>
                            </>
                          )}
                        </div>
                      ) : (
                        <>
                          <div className="col-md-4 col-sm-6 my-3">
                            {language ? (
                              <label
                                htmlFor=""
                                className="form-label m-0 fw-bold text-blue"
                              >
                                Doctor Language: {language}
                              </label>
                            ) : (
                              <>
                                <label
                                  htmlFor=""
                                  className="form-label m-0 fw-bold"
                                >
                                  Select Doctor Language:
                                </label>
                                <Form.Select
                                  className="meeting-status status-ongoing text-white text-start border-white font_16"
                                  aria-label="Default select example"
                                  onChange={(e) =>
                                    selectLangFunc(e.target.value, "doctor")
                                  }
                                >
                                  {constant?.language.map((item) => (
                                    <option value={item}>{item}</option>
                                  ))}
                                </Form.Select>
                              </>
                            )}
                          </div>
                          <div className="col-md-4 col-sm-6 my-3">
                            {patientLanguage ? (
                              <label
                                htmlFor=""
                                className="form-label m-0 fw-bold text-blue"
                              >
                                Patient Language: {patientLanguage}
                              </label>
                            ) : (
                              <>
                                <label
                                  htmlFor=""
                                  className="form-label m-0 fw-bold"
                                >
                                  Select Patient Language:
                                </label>
                                <Form.Select
                                  className="meeting-status  status-ongoing text-white text-start border-white font_16"
                                  aria-label="Default select example "
                                  onChange={(e) =>
                                    selectLangFunc(e.target.value, "patient")
                                  }
                                >
                                  {constant?.language.map((item) => (
                                    <option value={item}>{item}</option>
                                  ))}
                                </Form.Select>
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <div className="input-group mb-3">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa-solid fa-magnifying-glass"> </i>
                      </span>
                      <input
                        type="text"
                        {...register("prompt")}
                        className="form-control"
                        id="prompt"
                        value={searchTextValue}
                        placeholder={
                          parseInt(location.poc_type) == 7
                            ? "Hello I have a fever and a headache and some fatigue. What might be the problem? what do you need for accurate differential diagnosis?"
                            : parseInt(location.poc_type) == 2
                            ? "Please check the following prescription for interactions and indications. Please revise the prescription to remove interactions and ameliorate severe indications."
                            : " Send your message..."
                        }
                        onChange={(e) => {
                          setSearchTextValue(e.target.value);
                        }}
                      />
                      <div className="invalid-feedback">
                        {errors.prompt?.message}
                      </div>
                      {activeChat && !audible && (
                        <>
                          <div className="invalid-feedback">
                            {
                              "I can't hear you, please say something or ask for help"
                            }
                          </div>
                        </>
                      )}
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        className="search-btn"
                        type="button"
                        onClick={onSubmitChat}
                      >
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/icon/send1.svg"
                          }
                          alt="search"
                        />
                      </button>
                    </div>
                  </div>
                </>
              )}

              <div
                ref={chatBoxRef}
                onScroll={handleScroll}
                className="overflow-y-auto"
                style={{ maxHeight: "calc(100vh - 200px)" }}
              >
                {conversation?.map((entry, index) => (
                  <div
                    key={index}
                    ref={
                      index === conversation?.length - 1 ? lastMessageRef : null
                    }
                  >
                    <div className="bg-[#040404] rounded-lg  mb-2 overflow-auto subblock">
                      <div className="aiicon">
                        <img
                          src="/assets/images/logo.png"
                          alt="profile"
                          className="profile"
                          style={{ width: "50px", height: "50px" }}
                        />
                      </div>
                      <div>
                        <div className="d-flex gap-10 align-items-start mb-2  ">
                          <p className="pb-0 font_16 text-blue font_600">
                            <span>{entry?.role}</span>
                            <span className="ms-2 d-inline-block text-gray-500 font_400">
                              ({new Date(entry?.createdAt)?.toUTCString()})
                            </span>
                          </p>
                          <button
                            onClick={() => toggleMessage(index)}
                            className="border-0 p-0 bg-transparent"
                          >
                            {/* {visibleIndexes[index] ? "Hide" : "Show"} */}
                            <i
                              style={{ fontSize: 16 }}
                              className={`fa-solid mt-1 fa-eye${
                                visibleIndexes[index] ? "" : "-slash"
                              }`}
                            ></i>
                          </button>
                          {/* {parseInt(
                            localStorage.getItem("user_login_type_role")
                          ) == 4 &&
                            entry?.role == "Starpilot" &&
                            speakingText == entry?.response && (
                              <TextReader
                                index={index + 1}
                                text={translatedText}
                                speak={speak}
                                cancel={cancel}
                                speaking={speaking}
                                supported={supported}
                                voices={voices}
                                speakingText={speakingText}
                                setSpeakingText={setSpeakingText}
                              />
                            )} */}
                        </div>
                        {visibleIndexes[index] && (
                          <div>
                            <pre
                              className="mb-2 text-justify white-space-pre"
                              style={{ fontSize: 14 }}
                            >
                              {parse(entry?.transcript)}
                            </pre>

                            {(loadingSpeaker?.status &&
                              loadingSpeaker?.index == index + 1 && (
                                <img
                                  src="../assets/images/speakerLoader.gif"
                                  style={{ height: "47px" }}
                                  alt=""
                                  className="img-fluid"
                                />
                              )) ||
                              (audioData?.playStatus &&
                                audioData?.text == parse(entry) && (
                                  <button
                                    className="search-btn"
                                    type="button"
                                    onClick={() => {
                                      stopAudio();
                                    }}
                                  >
                                    <i className="fa-solid fa-pause text-white" />
                                  </button>
                                )) || (
                                <button
                                  className="search-btn"
                                  type="button"
                                  onClick={() => {
                                    pocCreateTextToSpeechCompletion(
                                      parse(entry),
                                      index + 1
                                    );
                                  }}
                                >
                                  <i className="fa-solid fa-volume-up text-white" />
                                </button>
                              )}

                            <audio
                              onEnded={handleAudioEnd}
                              style={{ height: 0, width: 0, opacity: 0 }}
                              ref={audioRef}
                              controls
                            >
                              <source src="" type="audio/mpeg" />
                            </audio>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showListeningModal && (
        <>
          <div
            className={`modal fade ${showListeningModal ? "show" : ""}`}
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            tabIndex="-1"
            style={{ display: showListeningModal ? "block" : "none" }}
          >
            <div className="modal-dialog prescription-modal modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Listening
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closeListeningModal}
                  />
                </div>
                <div className="modal-body">
                  <div className="text-center">
                    {!handleStartStopListening ? (
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/icons8-sound.gif"
                        }
                        alt="search"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn submit-btn font_18"
                    onClick={handleListening}
                  >
                    {handleStartStopListening ? "Start" : "Stop"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
};

export default StarpilotChat;

const MainBtnWrpper = styled.div`
  @media (max-width: 600px) {
    flex-wrap: wrap;
    justify-content: center !important;
    > .right {
      flex-wrap: wrap;
      p {
        text-align: center;
        width: 100%;
      }
      .leave-btn {
        width: 100%;
      }
    }
  }
`;
